import { writable } from 'svelte/store';
import type { OrderGroup } from "@shared/types/OrderGroup";

interface CartSuccess {
  orderGroup?: OrderGroup
}

export default writable<CartSuccess>({});
